import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { dictionaries } from './pagination.config'

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  constructor() {}
  @Input() total: number = 0
  @Input() pageParams = {
    page: 1,
    size: 10,
  }
  // public pageParams: any = {
  //   page: 1,
  //   size: 10,
  // }
  public i18nLabel = dictionaries
  /**
   * 发布搜索参数改变的回调
   */
  @Output() searchParams = new EventEmitter<any>()
  ngOnInit() {}

  pageSizeChange(e) {
    this.pageParams.size = e
    this.searchParams.emit(this.pageParams)
  }
  pageChange(e) {
    this.pageParams.page = e
    this.searchParams.emit(this.pageParams)
  }
}
